var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIconPen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58333 17.4167H5.88958L14.85 8.45625L13.5437 7.15L4.58333 16.1104V17.4167ZM2.75 19.25V15.3542L14.85 3.27708C15.0333 3.10903 15.2359 2.97917 15.4578 2.8875C15.6796 2.79583 15.9124 2.75 16.1562 2.75C16.4001 2.75 16.6369 2.79583 16.8667 2.8875C17.0964 2.97917 17.2951 3.11667 17.4625 3.3L18.7229 4.58333C18.9062 4.75139 19.0401 4.95 19.1244 5.17917C19.2088 5.40833 19.2506 5.6375 19.25 5.86667C19.25 6.11111 19.2081 6.34425 19.1244 6.56608C19.0407 6.78792 18.9069 6.99019 18.7229 7.17292L6.64583 19.25H2.75ZM14.1854 7.81458L13.5437 7.15L14.85 8.45625L14.1854 7.81458Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconPen);
export default __webpack_public_path__ + "static/media/common_icon_pen.3a537e2d124209bf8a998ac0c84ad8ae.svg";
export { ForwardRef as ReactComponent };